import { JustificationStatus } from '@schooly/api';
import { CalendarClockIcon, CalendarDoneIcon, CalendarTextIcon, theme } from '@schooly/style';

export const getJustificationStatusIcon = (justificationStatus: JustificationStatus) => {
  switch (justificationStatus) {
    case JustificationStatus.Pending:
    case JustificationStatus.Expired:
      return <CalendarClockIcon />;
    case JustificationStatus.Submitted:
      return <CalendarTextIcon />;
    case JustificationStatus.Closed:
      return <CalendarDoneIcon />;
  }
};

export const getJustificationStatusPalette = (justificationStatus: JustificationStatus) => {
  switch (justificationStatus) {
    case JustificationStatus.Pending:
    case JustificationStatus.Submitted:
      return {
        primary: theme.palette.common.orange,
        secondary: theme.palette.common.orange5,
        icon: theme.palette.common.orange,
      };
    case JustificationStatus.Expired:
      return {
        primary: theme.palette.error.main,
        secondary: theme.palette.error.superLight ?? '',
        icon: theme.palette.error.main,
      };
    case JustificationStatus.Closed:
      return {
        primary: theme.palette.common.grey2,
        secondary: theme.palette.common.lightBg,
        icon: theme.palette.common.grey,
      };
  }
};
